<template>
    <div>
      <transition name="modal" v-if="showModal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">

              <div class="modal-header">
                <h3>Ready to get in touch with RetainerDesk?</h3>
              </div>

              <div class="modal-body">
                  <div>Enter your phone number and we will be in touch shortly!</div>

                 			<input class="form-control" name="EMAIL" placeholder="Your Phone number" v-model="email" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Your Phone number '"
							 required="" type="email">
                             <br>
							<button @click="sendMail()" :disabled="valid" class="button button-contactForm">Send</button>
							<div v-if="valid">Thanks! We will come back to you soon!.</div>
              </div>

              <div class="modal-footer">
                  <div style="width:100%;">Or call us now<br><a href="tel:+46855109280">+46 8 551 092 80</a></div>
                  <button class="button button-light button-chosen"  @click="showModal = false">
                    <span v-if="!valid">Later</span><span v-else>Close</span>
                  </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
</template>



    <script>
    
    export default {
      props: ['start'],
        data() { 
            return {
                showModal: false,
                email: '',
			    valid: false,
            }
        },
        methods: {
            sendMail(data) {

                const obj = {
                    from: this.email,
                    to: 'taieb@retainerdesk.com'
                }

                if(this.email.length < 3) {
                    alert("Your phone number need to be valid");
                    return;
                }

                this.$store.dispatch('SEND_MAIL', obj);
                this.valid = true;
            },
    
            run() {
                this.showModal = false;
                setTimeout(() => {
                    if(localStorage.getItem('modalAd') != null) {
                        this.showModal = false;
                    } else {
                        this.showModal = true;
                        localStorage.setItem('modalAd', this.showModal);
                    }
                }, 15000);

            }
        },
        mounted() {

            //this.run();


        }
    }
    </script>
<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  min-width: 300px;
  max-width: 600px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>